export class UnauthorizedAccessError {

};
